// NumberAnimate class to animate numbers when they are in view
/* Usage: new NumberAnimate(".number-animate");
   html
   <div class="number-animate" 
     data-start="3000" 
     data-last="5000" 
     data-step="50" 
     data-speed="20">
  <span class="num">3000</span>
</div>
*/

class NumberAnimate {
  constructor(selector) {
    this.targets = document.querySelectorAll(selector);
    this.observerOptions = {
      root: null,
      threshold: 0.1,
    };
    this.init();
  }

  init() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const el = entry.target;
        if (entry.isIntersecting) {
          el.classList.add("animated");
          // allow custom start value
          const start = parseFloat(el.dataset.start) || 0;
          this.runNumberChange(start, el);
        } else {
          el.classList.remove("animated");
          // stop timer
          if (el.timer) clearTimeout(el.timer);
        }
      });
    }, this.observerOptions);

    this.targets.forEach((target) => observer.observe(target));
  }

  runNumberChange(currentNum, container) {
    // check if container is animated
    if (!container.classList.contains("animated")) return;

    const span = container.querySelector(".num");
    if (!span) return;

    // allow custom step and speed
    const last = parseFloat(container.dataset.last) || 100;
    const step = parseFloat(container.dataset.step) || 1;
    const speed = parseFloat(container.dataset.speed) || 50;

    if (currentNum >= last) {
      span.textContent = last;
      if (container.timer) clearTimeout(container.timer);
    } else {
      span.textContent = currentNum;

      // accumulate the number change
      let nextNum = +(currentNum + step).toFixed(1);

      container.timer = setTimeout(() => {
        this.runNumberChange(nextNum, container);
      }, speed);
    }
  }
}